import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

import { ApplicationLauncherItem } from './application-launcher-item';

/**
 * Application launcher component
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { ApplicationLauncherModule } from 'patternfly-ng/navigation';
 * // Or
 * import { ApplicationLauncherModule } from 'patternfly-ng';
 *
 * &#64;NgModule({
 *   imports: [ApplicationLauncherModule,...]
 * })
 * export class AppModule(){}
 * </pre></code>
 */

export class ApplicationLauncherComponent  implements OnInit {
  /**
   * Disable the application launcher button, default: false
   */
   disabled: boolean;

  /**
   * The navigation items used to build the menu
   */
   items: ApplicationLauncherItem[];

  /**
   *  Use a custom label for the launcher, default: Application Launcher
   */
   label: string;

  /**
   * Display items as a list instead of a grid, default: false
   */
   showAsList: boolean = false;

  /**
   * Flag to show icons on the launcher, default: true
   */
   showIcons: boolean = true;

  /**
   * The default constructor
   */
  constructor() {}

  /**
   * Initialize variable
   */
  ngOnInit(): void {
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-application-launcher',
  template: `<div><div class="applauncher-pf dropdown dropdown-kebab-pf" dropdown [ngClass]="{'applauncher-pf-block-list': !showAsList}"><a class="dropdown-toggle drawer-pf-trigger-icon" href="javascript:void(0)" dropdownToggle *ngIf="!disabled"><i class="fa fa-th applauncher-pf-icon" aria-hidden="true"></i> <span class="applauncher-pf-title">{{label || 'Application Launcher'}} <span class="caret" aria-hidden="true"></span> </span></a><a class="dropdown-toggle drawer-pf-trigger-icon disabled" href="javascript:void(0)" onclick="return false;" *ngIf="disabled"><i class="fa fa-th applauncher-pf-icon" aria-hidden="true"></i> <span class="applauncher-pf-title">{{label || 'Application Launcher'}} <span class="caret" aria-hidden="true"></span></span></a><ul class="dropdown-menu dropdown-menu-right" role="menu" *dropdownMenu><li class="applauncher-pf-item" *ngFor="let item of items"><a class="applauncher-pf-link" href="{{item.url}}" target="{{item.target || '_blank'}}" title="{{badge.tooltip}}" role="menuitem" *ngFor="let badge of item.badges"><i class="applauncher-pf-link-icon pficon {{item.iconStyleClass}}" aria-hidden="true" [ngClass]="{hidden: !showIcons}" *ngIf="item.iconStyleClass"></i> <span class="applauncher-pf-link-title">{{item.title}}</span></a></li></ul></div></div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'disabled': [{ type: Input },],
'items': [{ type: Input },],
'label': [{ type: Input },],
'showAsList': [{ type: Input },],
'showIcons': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
